import { SearchForm } from './SearchForm.jsx';
import { SearchResults } from './SearchResults.jsx';

export function CatalogPage() {
  return (
    <>
      <SearchForm />
      <SearchResults />
    </>
  );
}
